import { render, staticRenderFns } from "./GraphDetail33.vue?vue&type=template&id=b52f2722&scoped=true"
import script from "./GraphDetail33.vue?vue&type=script&lang=js"
export * from "./GraphDetail33.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52f2722",
  null
  
)

export default component.exports